import { Bindable, NotifyProperty, nameof } from "bindable-data";
import { INetworkClient } from "../../../../networking/INetworkClient";
import { WedgeRewardType } from "./WedgeRewardType";
import { WedgeRewardData as WedgeRewardData } from "./WedgeRewardData";
import { GoldenWheelWedgeDto } from "by/gamefactory/cityversetycoon/networking/data/responses/dailywheel/goldenwheel/GoldenWheelWedgeDto";
import { IPiggyWheelModel } from "./IPiggyWheelModel";
import { PiggyWheelWedgeDto } from "../../../../networking/data/responses/dailywheel/piggyWheel/PiggyWheelWedgeDto";
import { PiggyWheelStatusDto } from "../../../../networking/data/responses/dailywheel/piggyWheel/PiggyWheelStatusDto";
import { ObjectFieldsChecker } from "../../../../../tools/ObjectFieldsChecker";

export class PiggyWheelModel extends Bindable implements IPiggyWheelModel {
    public readonly wedges: NotifyProperty<Array<PiggyWheelWedgeDto>>;
    public readonly rewardWedgeId: NotifyProperty<string>;
    public readonly priceInTokens: NotifyProperty<string>;

    private readonly networkClient: INetworkClient;

    get rewardWedgeIndex(): number {
        return this.wedges.value.findIndex((item) => item.id == this.rewardWedgeId.value);
    }

    public constructor(networkClient: INetworkClient) {
        super();
        this.networkClient = networkClient;
        this.wedges = new NotifyProperty<Array<GoldenWheelWedgeDto>>(this, nameof(this, "wedges"), []);
        this.rewardWedgeId = new NotifyProperty<string>(this, nameof(this, "rewardWedgeId"), "");
        this.priceInTokens = new NotifyProperty<string>(this, nameof(this, "priceInTokens"), "");
    }

    public reset(): void {
        this.wedges.setValue([]);
        this.rewardWedgeId.setValue("");
        this.priceInTokens.setValue("");
    }

    public async loadPiggyWheelStatus(): Promise<void> {
        const piggyWheelStatusDto = await this.networkClient.getPiggyWheelStatus();
        this.validateGoldenWheelStatusDto(piggyWheelStatusDto);
        this.updateValuesFromDto(piggyWheelStatusDto);
    }

    public async claimPiggyWheelReward(): Promise<void> {
        const result = await this.networkClient.claimPiggyWheelReward();
        ObjectFieldsChecker.throwIfInvalidFields(result, [
            "rewardWedgeId"
        ]);
        this.rewardWedgeId.setValue(result.rewardWedgeId);
    }

    private validateGoldenWheelStatusDto(goldenWheelStatusDto: PiggyWheelStatusDto): void {
        ObjectFieldsChecker.throwIfInvalidFields(goldenWheelStatusDto, [
            "priceInTokens"
        ]);
    }

    private updateValuesFromDto(dailyBonusWheelStatusDto: PiggyWheelStatusDto): void {
        this.wedges.setValue(dailyBonusWheelStatusDto.wedges || []);
        this.priceInTokens.setValue(dailyBonusWheelStatusDto.priceInTokens);
    }

    public getWedgeRewardData(rewardDto: PiggyWheelWedgeDto): WedgeRewardData {
        if (rewardDto.reward.coins != undefined && rewardDto.reward.coins > 0) {
            return new WedgeRewardData(WedgeRewardType.Coin, rewardDto.reward.coins);
        }
        if (rewardDto.reward.shields != undefined && rewardDto.reward.shields > 0) {
            return new WedgeRewardData(WedgeRewardType.Shield, rewardDto.reward.shields);
        }
        if (rewardDto.reward.diceRolls != undefined && rewardDto.reward.diceRolls > 0) {
            return new WedgeRewardData(WedgeRewardType.DiceRoll, rewardDto.reward.diceRolls);
        }
    }
}
